import React from 'react';
import { TrendingDown, Settings, Zap, Eye } from 'lucide-react';

const WhyUsSection = () => {
  const benefits = [
    {
      icon: TrendingDown,
      title: 'Optimizuojame Jūsų logistikos sąnaudas',
      description: 'Efektyvūs procesai ir patirtis padeda sutaupyti jūsų lėšas'
    },
    {
      icon: Settings,
      title: 'Siūlome individualius sprendimus',
      description: 'Kiekvienas verslas unikalus – pritaikome paslaugas jūsų poreikiams'
    },
    {
      icon: Zap,
      title: 'Dirbame lanksčiai pagal Jūsų poreikius',
      description: 'Greita reakcija į pokyčius ir prisitaikymas prie jūsų grafiko'
    },
    {
      icon: Eye,
      title: 'Užtikriname visišką skaidrumą',
      description: 'Nuolatinės ataskaitos ir pilna atsargų bei procesų kontrolė'
    },
  ];

  return (
    <section className="py-16 bg-white" data-testid="why-us-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Kodėl rinktis mus?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Mūsų patirtis ir profesionalumas – jūsų verslo augimo pagrindas
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {benefits.map((benefit, index) => {
            const Icon = benefit.icon;
            return (
              <div
                key={index}
                className="flex items-start space-x-4 p-6 bg-gray-50 rounded-lg hover:bg-blue-50 transition-colors"
                data-testid={`benefit-card-${index}`}
              >
                <div className="flex-shrink-0">
                  <div className="bg-blue-600 p-3 rounded-lg">
                    <Icon className="h-6 w-6 text-white" />
                  </div>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">{benefit.title}</h3>
                  <p className="text-gray-600">{benefit.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyUsSection;